// extracted by mini-css-extract-plugin
module.exports = {"approval-request":"ApprovalRequestsView_approval-request__DFBBC"};